<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle || 'Reservations of Day'"
      [canGoBack]="true"
      [customBack]="jobBackPage" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @for (property of propertiesWithEvents; track property) {
      <tidy-row>
        <tidy-text
          [header]="property?.name || property?.address" />
      </tidy-row>
      @for (item of property?.items; track item) {
        @if (!item?.booking) {
          <app-reservation-card
            [reservation]="item"
            [address]="property?.name || property?.address"
            [addressId]="property?.id"
            size="md" />
          @if (item?.source_data) {
            <tidy-row class="no-padding source-data-link-row">
              <div class="source-data-link" (click)="toggleSourceData(item?.id || 'default')">
                <tidy-text [body]="'View source data'" />
                <ion-icon
                  [name]="isSourceDataExpanded(item?.id || 'default') ? 'chevron-up' : 'chevron-down'"
                  class="source-data-icon" />
              </div>
            </tidy-row>
            <tidy-row class="source-data-content"
              [class.expanded]="isSourceDataExpanded(item?.id || 'default')"
              [@slideAnimation]="isSourceDataExpanded(item?.id || 'default') ? 'expanded' : 'collapsed'">
              <div class="source-data-inner">
                @for (sourceItem of item?.source_data | keyvalue; track sourceItem; let i = $index) {
                  <div [class]="'container bullet-item'" style="max-inline-size: 80%;">
                    <tidy-text [body]="'• ' + sourceItem.key + ': ' + util.formatSourceDataValue(sourceItem.value)" />
                  </div>
                }
              </div>
            </tidy-row>
          }
        }
      }
    }
  </tidy-wrapper>
</ng-template>

            @if (!isRightSideContent) {
              <app-scroll-wrapper [templateContent]="content" />
            }

            @if (isRightSideContent) {
              <ion-content class="ion-content-right-column">
                <ng-container *ngTemplateOutlet="content" />
              </ion-content>
            }
